import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import ReactApexChart from "react-apexcharts";

interface TimelineCardProps {
  options: any;
  series: any[];
}

const TimelineCard: React.FC<TimelineCardProps> = ({ options, series }) => {
  return (
    <Card>
      <CardHeader>
        <h4 className="card-title mb-0">Leads vs Daily Cap</h4>
      </CardHeader>
      <CardBody>
        <ReactApexChart
          options={options}
          series={series}
          type="line"
          height={350}
        />
      </CardBody>
    </Card>
  );
};

export default TimelineCard;
